"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const infocircle = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-infocircle` : '') + (description ? ` desc-infocircle` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-infocircle"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-infocircle"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_972_2218)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0ZM12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5ZM11.25 9.75C12.0297 9.75 12.6704 10.3449 12.7431 11.1055L12.75 11.25V15C12.75 15.3797 13.0322 15.6935 13.3982 15.7432L13.5 15.75H14.25C14.6642 15.75 15 16.0858 15 16.5C15 16.8797 14.7178 17.1935 14.3518 17.2432L14.25 17.25H13.5C12.3091 17.25 11.3344 16.3248 11.2552 15.154L11.25 15V11.25H10.5C10.0858 11.25 9.75 10.9142 9.75 10.5C9.75 10.1203 10.0322 9.80651 10.3982 9.75685L10.5 9.75H11.25ZM11.625 6L11.7476 6.0066C12.3112 6.06768 12.75 6.5451 12.75 7.125C12.75 7.74632 12.2463 8.25 11.625 8.25C11.0037 8.25 10.5 7.74632 10.5 7.125C10.5 6.5451 10.9388 6.06768 11.5024 6.0066L11.625 6Z",
    fill: "inherit"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_972_2218"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
var _default = exports.default = infocircle;